
function formatDate (date: Date, isStartDate: boolean = true) {
  const appendTime = isStartDate ? 'T00:00:00Z' : 'T23:59:59Z'
  const year = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(date)
  const month = new Intl.DateTimeFormat('en', { month: '2-digit' }).format(date)
  const day = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(date)
  return `${year}-${month}-${day}${appendTime}`
}

function formatDateForUrl (date: Date) {
  const year = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(date)
  const month = new Intl.DateTimeFormat('en', { month: '2-digit' }).format(date)
  const day = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(date)
  return `${year}-${month}-${day}`
}

function displayFormattedDateInFilter (date: Date) {
  const formattedShortMonth = new Intl.DateTimeFormat('en', { month: 'short' }).format(date)
  return `${formattedShortMonth} ${date.getDate()}, ${date.getFullYear()}`
}

function isSameDay (startDate: string, endDate: string) {
  return startDate === endDate
}

function getMonthStartDate () {
  let monthStartDate = new Date()
  monthStartDate.setDate(monthStartDate.getDate() - 30)
  monthStartDate.setHours(0, 0, 0, 0)
  return monthStartDate
}

function getYesterday () {
  let yesterday = new Date()
  yesterday.setDate(yesterday.getDate() - 1)
  yesterday.setHours(23, 59, 59, 0)
  return yesterday
}

export default { formatDate, formatDateForUrl, displayFormattedDateInFilter, isSameDay, getMonthStartDate, getYesterday }
